import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext, useEffect, useState } from 'react';
import { useDebouncedCallback } from 'use-debounce';
import { Input, useLocalizeMessage, Spinner } from 'libs.nucleus';
import { DataTransferTemplateContext } from '../../../contexts/data_transfer_template/data_transfer_template.context';
export const ValidatedTemplateNameInput = ({ value, onChange, onValidationChange, width = 'full', required = true, id = 'templateName', }) => {
    const translate = useLocalizeMessage();
    const { checkIfTemplateNameIsValid } = useContext(DataTransferTemplateContext);
    const [isValidating, setIsValidating] = useState(false);
    const [isValid, setIsValid] = useState(true);
    // Create a debounced function to validate the template name
    const validateTemplateName = useDebouncedCallback(async (name) => {
        if (!name) {
            setIsValid(false);
            onValidationChange?.(false);
            setIsValidating(false);
            return;
        }
        setIsValidating(true);
        const isValidName = await checkIfTemplateNameIsValid(name);
        setIsValid(isValidName);
        setIsValidating(false);
        onValidationChange?.(isValidName);
    }, 500);
    // Trigger validation when value changes
    useEffect(() => {
        if (value) {
            validateTemplateName(value);
        }
    }, [value, validateTemplateName]);
    const handleChange = (e) => {
        const newValue = e.target.value;
        onChange(newValue);
    };
    return (_jsxs("div", { className: 'relative', children: [_jsx(Input, { required: required, id: id, label: translate('Name'), value: value, onChange: handleChange, width: width, hasError: !isValid, errorMessage: !isValid ? translate('Template name already exists or is invalid.') : '' }), isValidating && (_jsx("div", { className: 'absolute end-0 top-0', children: _jsx(Spinner, { size: 'sm' }) }))] }));
};
